import { Controller } from "@hotwired/stimulus";
import videojs from "video.js";

// Connects to data-controller="media-teachings"
export default class extends Controller {
  static targets = [
    "form",
    "startViewDate",
    "videoViewingPosition",
    "completeButton",
    "submitType",
    "movieStatus",
  ];

  static values = {
    videoStartTime: Number,
    registerHistoryPath: String,
  };

  connect() {
    this.IntervalId = null;
    this.startViewDate = null;

    this.video = videojs("movie");
    this.video.currentTime(this.videoStartTimeValue);

    this.video.on("playing", () => {
      this.startViewDate ||= new Date();
      this.sendViewingHistory();
      this.startInterval();
    });

    this.video.on("pause", () => {
      this.stopInterval();
    });

    this.video.on("ended", () => {
      this.movieStatusTarget.value = "playing";
      this.sendViewingHistory();
      this.completeButtonTarget.disabled = false;
      this.stopInterval();
    });
  }

  // 完了ボタン押下時の送信処理
  handleCompleteSubmit(event) {
    event.preventDefault();

    this.videoViewingPositionTarget.value = this.video.currentTime();
    this.startViewDateTarget.value = (this.startViewDate || new Date()).toISOString();

    this.submitTypeTarget.value = "complete";
    this.movieStatusTarget.value = "stop";

    this.completeButtonTarget.disabled = true;
    this.completeButtonTarget.form.submit();
  }

  // 動画再生中、3秒ごとに履歴を送信するインターバルを開始
  startInterval() {
    if (this.IntervalId || this.video.paused()) return;

    this.movieStatusTarget.value = "playing";

    this.IntervalId = setInterval(() => {
      this.sendViewingHistory();
    }, 3000);
  }

  // 再生停止時にインターバルを解除
  stopInterval() {
    if (this.IntervalId || this.video.paused()) {
      this.movieStatusTarget.value = "stop";
      clearInterval(this.IntervalId);
      this.IntervalId = null;
    }
  }

  // 視聴履歴の送信処理
  async sendViewingHistory() {
    this.videoViewingPositionTarget.value = this.video.currentTime();
    this.startViewDateTarget.value = (this.startViewDate || new Date()).toISOString();
    this.submitTypeTarget.value = 'incomplete';

    const formData = new FormData(this.completeButtonTarget.form);
    const csrfToken = document.querySelector("[name='csrf-token']").content;

    // TODO：エラーキャッチ後の動作については田村さんが大学側に確認を行っているので、回答が出次第、別PRで対応を行う。
    // 現状はconsole.log出力で問題ない。
    try {
      const response = await fetch(this.registerHistoryPathValue, {
        method: "POST",
        body: formData,
        headers: {
          "X-CSRF-Token": csrfToken,
        },
      });

      if (!response.ok) {
        console.error("視聴履歴送信失敗:", response.status, response.statusText);
      }
    } catch (error) {
      console.error("視聴履歴送信時にエラー:", error);
    }
  }
}
